// @flow
import React from 'react';

const HALF_DEFAULTPAGE = [1024 / 2, 768 / 2];

export function getBestMode(w, h) {
	w = w || window.innerWidth;
	h = h || window.innerHeight;
	const portrait = w < h;
	return portrait && w <= 800 || w < HALF_DEFAULTPAGE[0] || h < HALF_DEFAULTPAGE[1]
		? 'mobile' : 'desktop';
}


// WEBPACK FOOTER //
// ./lib/components/modeswitcher.js